import {
  Body,
  Icon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@growtherapy/sprout-ui";
import { RejoinModalViewModel } from "./types";
import { faWifiSlash } from "@fortawesome/pro-duotone-svg-icons";

export function RejoinModal({
  isOpen,
  onJoin: handleJoin,
  isLoading,
}: RejoinModalViewModel) {
  return (
    <Modal className="sm:mt-[10%]" isOpen={isOpen}>
      <ModalHeader>
        <Icon className="mr-2" icon={faWifiSlash} />
        Connection lost
      </ModalHeader>
      <ModalBody>
        <Body.Default>
          Your connection was interrupted. Please try rejoining your session
          below.
        </Body.Default>
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: "rejoin-session",
            "aria-label": isLoading ? "Reconnecting" : "Reconnect",
            use: "primary",
            loading: isLoading,
            onClick: handleJoin,
            actionContent: "Rejoin session",
          },
        ]}
      />
    </Modal>
  );
}
